document.addEventListener("DOMContentLoaded", () => {
  const villaCards = document.querySelectorAll(".villa-card");

  villaCards.forEach(card => {
    const badge = card.querySelector(".img-badge");
    const link = card.querySelector(".villa-link");

    if (!link) return;

    if (badge) {
      // désactivation du lien
      link.addEventListener("click", e => {
        e.preventDefault();
        e.stopPropagation();
      });

      // style visuel
      link.style.cursor = "not-allowed";
      link.style.pointerEvents = "auto"; // garder le clic capturable
    } else {
      // si pas d'img-badge → on s'assure que les styles soient normaux
      link.style.cursor = "";
      link.style.pointerEvents = "";
    }
  });
});
